import React from 'react'
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle} from '@fortawesome/free-solid-svg-icons';

const Recepisse = ({dataPerson}) => {

  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header >
        <Modal.Title>Inscription réussie</Modal.Title>
        <FontAwesomeIcon icon={faCheckCircle} className="green-icon m-2" size="lg" />
        </Modal.Header>
        <Modal.Body>
            <div className="container ">
            <div className='text-dark text-centered'>
                 <span style={{fontWeight:'bold'}}>Félicitations</span> !!! Vous venez de terminer votre {dataPerson.est_renscrit ? "Reinscription" : "Inscription" }. 
            </div>
            <div>
                    Un mail de confirmation vous sera envoyé à  : <span className='fw-bolder'>{dataPerson?.email}</span> 
                  </div>
                <div>
                    Prenom & Nom : <span>{dataPerson.prenom +" " + dataPerson.nom}</span>
                </div>
                <div>
                    Date & Lieu de Naissance : <span>{dataPerson.date_naissance + " à " +dataPerson.lieu_naissance}</span>
                </div>
                <div>
                  {dataPerson.est_renscrit ? "Code Permanent" : "Numéro de Table" } : <span>{dataPerson.codePermanent}</span>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <Link to='/'>
              <Button variant="outline-success" onClick={handleClose}>
                Fermer
              </Button>
              </Link>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Recepisse

export function  Paiement ({dataPerson}) {

  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header >
        <Modal.Title>Paiement effectué </Modal.Title>
        <FontAwesomeIcon icon={faCheckCircle} className="green-icon m-2" size="lg" />
        </Modal.Header>
        <Modal.Body>
            <div className="container ">
            <div className='text-dark text-centered'>
                 <span style={{fontWeight:'bold'}}>Paiement Effectué avec succés !</span>  
            </div>
            <div>
                    Adresse mail  : <span className='fw-bolder'>{dataPerson?.email}</span> 
                  </div>
                <div>
                    Code Permanent: <span>{dataPerson.codePermanent}</span>
                </div>
                <div>
                    Campagne de paiement : <span>{dataPerson.campagne}</span>
                </div>
                <div>
                    Numéro Transaction : <span>{dataPerson.num_transaction}</span>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <Link to='/'>
              <Button variant="outline-success" onClick={handleClose}>
                Fermer
              </Button>
              </Link>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export function RecepisseVote ({dataPerson}) {

  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header >
        <Modal.Title>Vote réussie</Modal.Title>
        <FontAwesomeIcon icon={faCheckCircle} className="green-icon m-2" size="lg" />
        </Modal.Header>
        <Modal.Body>
            <div className="container ">
            <div className='text-dark text-centered'>
                 <span style={{fontWeight:'bold'}}>Ton vote a été enregistrée .  </span> 
            </div>
            <div>
                    Un mail de confirmation vous a été envoyé à  : <span className='fw-bolder'>{dataPerson?.email}</span> 
                  </div>
                <div>
                    Prenom & Nom : <span>{dataPerson.prenom +" " + dataPerson.nom}</span>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <Link to='/'>
              <Button variant="outline-success" onClick={handleClose}>
                Fermer
              </Button>
              </Link>
        </Modal.Footer>
      </Modal>
    </>
  )
}